// -------------
// ツールチップの開閉/SP
// -------------

$(function(){
  // 画面幅が指定サイズかどうか
  function isMobile() {
    return $(window).width() < 960;
  }

  $('.p-plan-tooltip').on('click', function(e){
    if (!isMobile()) return; // PCは無視

    e.stopPropagation();
    var $this = $(this);

    // 他のツールチップを閉じる（自分は閉じない）
    $('.p-plan-tooltip.active').not($this).removeClass('active');

    // 自分には常に active を付与
    $this.addClass('active');
  });

  // ページの他の場所をタップしたら全て閉じる
  $(document).on('click', function(){
    if (!isMobile()) return;
    $('.p-plan-tooltip.active').removeClass('active');
  });
});
